import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { closePopup } from '../../actions/uiActions';
import { deleteFolder } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class DeleteFolder extends React.Component {

    handleDeleteFolder = (event) => {
        event.preventDefault()
        this.props.deleteFolder(this.props.popupInfo)

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        let folder = this.props.folderList.find(x => x.id === this.props.popupInfo)
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Delete this Folder?'}
                {' '}
            </DialogTitle>
            <DialogContent>
                
                    <div className="passwordResetbox">
                        <h5 className="DeletepepsiText">{folder.folderName}</h5>
                        <button
                            className="btn"
                            onClick={this.handleDeleteFolder}
                        >
                            Delete
                  </button>
                    </div>
               
            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        folderList: state.users.folderList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, deleteFolder }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteFolder)
